/**
 * Termly consent categories exposed to our CMP integration.
 */
export interface TermlyConsentState {
  advertising?: boolean;
  analytics?: boolean;
}

/**
 * Maps Termly consent to Ours Privacy `default_user_consent_properties`
 * (`analytics`, `marketing`), including internal-traffic suppression for marketing.
 */
export function mapTermlyToOurs(
  consentState: TermlyConsentState | null | undefined
): Record<string, boolean> {
  if (!consentState) return {};

  const result: Record<string, boolean> = {};
  const isInternalTraffic =
    localStorage.getItem("is-internal-traffic") === "true";

  if (consentState.advertising !== undefined) {
    result.marketing = !isInternalTraffic && consentState.advertising;
  }

  if (consentState.analytics !== undefined) {
    result.analytics = consentState.analytics;
  }

  return result;
}
